import { AdministrationServicePath, COUNTRIES, BLACK_LIST } from "utils/constants";
import permissions from "app/permissions";
import EditGroupBlacklistCountries from "./Edit";

//permissions
export const resources = {
  name: AdministrationServicePath + COUNTRIES + "/" + BLACK_LIST,
  title: "Вражески държави",
  edit: <EditGroupBlacklistCountries />,
  editPermission: permissions.canPreviewGroupBlacklistCountriesInfo,
};
